import { LegacyCard, List, Text } from "@shopify/polaris"

import { TooltipByIcon } from "@/components"

export interface IProAskedQuestionsProps {
  title: string // 标题
  list: string[] // 列表
  key?: string | number // 唯一标识
  desc?: string // 描述
  jumpUrl?: string // learn more url
  subTitle?: string // 子标题
}

const AskedQuestions = (props: IProAskedQuestionsProps) => {
  const { title, key, list, desc, jumpUrl } = props
  return (
    <LegacyCard>
      <LegacyCard.Section>
        <div className="flex flex-col gap-1" key={key}>
          <div className="flex flex-col gap-1">
            <div className="flex items-center gap-1">
              <Text variant="bodyMd" as="span" fontWeight="medium">
                {title}
              </Text>
              {jumpUrl && (
                <div className="mb-[-6px]">
                  <TooltipByIcon content={t("LearnMore")} jumpUrl={jumpUrl} />
                </div>
              )}
            </div>
            {desc && (
              <Text variant="bodyMd" as="span" tone="subdued">
                {desc}
              </Text>
            )}
          </div>
          {/* 只有一条文本，不展示点 */}
          {list?.length <= 1 ? (
            <Text variant="bodyMd" as="span" tone="subdued">
              {list?.[0]}
            </Text>
          ) : (
            <List type="bullet">
              {list.map((item) => (
                <List.Item key={item}>
                  <Text variant="bodyMd" as="span" tone="subdued">
                    {item}
                  </Text>
                </List.Item>
              ))}
            </List>
          )}
        </div>
      </LegacyCard.Section>
    </LegacyCard>
  )
}

export default AskedQuestions
